import React, { useState } from 'react'
import adminStyles from './adminStyles.module.css'
import axios from 'axios'

const AddOffer= () => {
  const[oname,setOname]=useState("")
  const[odesc,setOdesc]=useState("")
  const[datetime,setDatetime]=useState("")

  const addOfferData=(e)=>{
      e.preventDefault();
        axios.post(`https://backendsurgylife-1.onrender.com/offer`,{
            oname,
            odesc,
            datetime,
          
          })
        .then((res)=>{
            alert("Offer Added Successfully");
            setOname("")
            setOdesc("");
            setDatetime("");
        })
        .catch((err)=>{
         alert("Error while adding  Offers :")
        })
}
  return (
    <main>
      

                      <section>
                       <div className='container'>
                           <div className='row'>
                               <div className='col-md-8 '>

                                <div className={adminStyles.bx_shadow}>
                                 <form onSubmit={addOfferData}>
                                  <div className='mb-3'>

                                <input 

                                 type='text'
                                 name='oname'
                                  placeholder='Offer Name' 
                                  className='form-control'
                                  value={oname}
                                  onChange={
                                    (e)=>setOname(e.target.value)
                                  }
                                  />

                                  </div>

                                  <div className='mb-3'>

                                   <textarea 
                                   className='form-control'
                                   placeholder='Offer Description'
                                   value={odesc}
                                   onChange={
                                    (e)=>setOdesc(e.target.value)
                                   }
                                   >

                                   </textarea>

                                  </div>


                                    <div className='mb-3'>

                                <input 

                                 type='dateTime-local'
                                 name='datetime'
                                  placeholder='Offer Expires' 
                                  className='form-control'
                                  value={datetime}

                                  onChange={
                                    (e)=>setDatetime(e.target.value)
                                  }
                                  />

                                  </div>


                                    <div className='mb-3'>
                                      
                                <input 
                                type='submit' 
                                value='Add Offer'
                                className='btn btn-success'/>  

                                    </div>

                                 </form>

                          

                                </div>

                               </div>
                           </div>
                       </div>
                   </section>
    </main>
  )
}

export default AddOffer
